import { AttachmentButton, ProviderDocument, ProviderGuarantor, Spinner } from '@enter/core';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { RootStore } from 'stores';
import * as S from './guarantor-document-dialog.styles';

interface IGuarantorDocumentDialogProps {
    claimId: string;
    guarantor?: ProviderGuarantor;
    onClose: () => void;
}

export const GuarantorDocumentDialog: React.FunctionComponent<IGuarantorDocumentDialogProps> = inject('rootStore')(
    observer(
        (props: IGuarantorDocumentDialogProps): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');
            if (!rootStore) {
                return <></>;
            }
            const { claimStore } = rootStore;
            const { claimId, guarantor, onClose } = props;
            const [documents, setDocuments] = useState<ProviderDocument[] | undefined>();
            const handleDownload = (id: string): (() => Promise<void>) => {
                return async (): Promise<void> => {
                    const docUrl = await claimStore.loadDocumentDownloadUrl(id);
                    if (docUrl && docUrl.url) {
                        window.open(docUrl.url, '_blank');
                    }
                };
            };
            const handleClose = (): void => {
                onClose && onClose();
            };
            useEffect(() => {
                (async (): Promise<void> => {
                    if (guarantor && guarantor.id) {
                        const docs = await claimStore.getGuarantorBillingDocuments(claimId, guarantor.id);
                        setDocuments(docs);
                    }
                })();
            }, [claimId, claimStore, guarantor]);
            const attachments = _.compact(
                _.map(documents, document => {
                    const { id, filename, filesize } = document;
                    if (id && filename) {
                        return (
                            <AttachmentButton
                                key={id}
                                filename={filename}
                                filesize={filesize}
                                onDownload={handleDownload(id)}
                            />
                        );
                    }
                }),
            );

            return (
                <S.DialogBody>
                    <S.InputRow>
                        {_.isUndefined(documents) && <Spinner />}
                        {!_.isEmpty(documents) && <S.InputColumn>{attachments}</S.InputColumn>}
                        {_.isEmpty(documents) && <S.Message>No bills found</S.Message>}
                    </S.InputRow>
                    <S.Button onClick={handleClose}>OK</S.Button>
                </S.DialogBody>
            );
        },
    ),
);
